import { StyleSheet,Dimensions } from 'react-native';
import { SIZES, PALETTE, MQ_TABLET} from '../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
const WINDOW_WIDTH = Dimensions.get('window').width;


export default MediaQueryStyleSheet.create({
  root: {
    flex: 1,
    paddingVertical: 15,
  },
  content: {
    flex: 1,
    paddingHorizontal: 40,
  },
  changePasswordSuccess: {
    paddingTop: 120,
    marginBottom: 20,
    textAlign: 'center',
  },
  buttonStyle:{
    
  }
},
{
    [MQ_TABLET]: {
    root:{
      alignItems:'center',
      paddingVertical:0,
    },
    content:{
    width:WINDOW_WIDTH*0.6,
     alignSelf:'center',
     borderWidth: 2,
     borderColor: PALETTE.primaryStrokeLine,
     paddingHorizontal:0,
     marginBottom: 40,
     marginTop: 40,
    },
     buttonStyle:{
      width:WINDOW_WIDTH*0.3,
      alignSelf:'center',
      marginTop:100,
    },
    changePasswordSuccess:{
      paddingTop:60,
    }

  }

});
